<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Fitness Challenges</h1>
  </div>
  <div class="flex flex-row justify-end gap-3 pb-4">
    <button
      nz-button
      nzType="primary"
      [routerLink]="['/physical-fitness/challenges/create']"
    >
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Create Fitness Challenges
    </button>
  </div>
  <div class="flex flex-row justify-end mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for challenges"
        />
      </nz-input-group>
    </div>
  </div>

  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Physical Fitness Challenges</span>
      </div>
      <div class="flex gap-2">
        <nz-switch
          [(ngModel)]="showTestCount"
          (ngModelChange)="showTestUsers()"
          nzCheckedChildren="hide test challenges"
          nzUnCheckedChildren="show test challenges"
        ></nz-switch>
        <div nz-col>
          <button
            class="btn-color"
            nz-button
            nzSize="small"
            nzType="primary"
            (click)="resetFilter()"
          >
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <nz-spin [nzSpinning]="loader" nzTip="Fetching Fitness Challenges......">
    <nz-table
      #Table
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="tableData"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalChallengesCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="page"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>Challenge Name</th>
          <th>Internal Challenge Name</th>
          <th>Exercise Name</th>
          <th>Created At</th>
          <th>Active</th>
          <th>Countdown(In Sec)</th>
          <th nzWidth="25%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data">
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ data.name }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ data.internalChallengeName }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ data.exerciseName }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ utils.convertEpochToFormattedDate(data.createdAt) }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ data.active ? "yes" : "no" }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }">
            {{ data.countdown }}
          </td>
          <td [ngClass]="{ 'bg-gray-200': !data.active }" nzRight>
            <div class="flex items-center justify-evenly">
              <span nz-tooltip nzTooltipTitle="View Fitness Challenge">
                <button
                  [routerLink]="[
                    '/physical-fitness/challenges/update/' + data.id
                  ]"
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                >
                  <span nz-icon nzType="eye" nzTheme="outline"></span>
                </button>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
